import Model from './Model'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
dayjs.extend(utc)

export default class DiscoveryPage extends Model {
  resource() {
    return 'admin/discoveries/pages'
  }

  get addedDate() {
    return dayjs.utc(this.created_at).local().format('MMMM DD, YYYY')
  }
}
